import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// One-time migration from the legacy auth-token key so existing users aren't logged out.
// (Safe to remove after a few releases.)
try {
  if (!localStorage.getItem("kaaya_token")) {
    // Migrate from prior brand keys (tuha_token, and older nouvelle_token) so existing
    // logged-in users are NOT signed out by the KAAYA rebrand.
    const legacy =
      localStorage.getItem("tuha_token") ||
      localStorage.getItem("nouvelle_token");
    if (legacy) localStorage.setItem("kaaya_token", legacy);
  }
  localStorage.removeItem("tuha_token");
  localStorage.removeItem("nouvelle_token");
} catch (_) { /* storage unavailable */ }

// Attach Bearer token from localStorage as a fallback (for testing agent which sets cookies + tokens)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kaaya_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Paywall: a 402 means the free trial / plan lapsed — send the user to Billing.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 402 && typeof window !== "undefined") {
      if (!window.location.pathname.startsWith("/billing")) {
        window.location.assign("/billing");
      }
    }
    return Promise.reject(err);
  }
);
